module.exports = __webpack_public_path__ + "img/icon-chevron.cd1f5432.svg";